import * as React from "react";
import { useDebounce } from "../../../utils/hooks/use-debounce";
import { HiMagnifyingGlass } from "react-icons/hi2";

function InputSearch(props) {
  const {
    placeholder = "검색",
    onChange,
    isMagnifyingGlass = true,
    width = "w-[14rem]",
    padding,
  } = props;
  // const [keyword, setKeyword] = React.useState();
  // const debouncedKeyword = useDebounce(keyword);

  // React.useEffect(() => {
  //   if (typeof debouncedKeyword === "string") {
  //     onChange(debouncedKeyword);
  //   }
  // }, [debouncedKeyword]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="relative">
      <div className="absolute inset-y-0 right-0 flex items-center pl-3 pointer-events-none">
        {isMagnifyingGlass && (
          <HiMagnifyingGlass className="absolute right-4 text-[20px]" />
        )}
      </div>
      <input
        type="text"
        id="default-search"
        className={`${width} h-8 text-black border border-button-grey rounded-[4px] p-[6px] focus:outline-none ${padding}`}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
}

export default InputSearch;
